/*
 * Copyright © 2024. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import summaryStyle from "./summaryStyle";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";
import { Box } from "@mui/material";

type PersonalAffectionProps = {
  product: AbstractCase;
  title: string;
};
const PersonalAffection = ({ product, title }: PersonalAffectionProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>{title}</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"name"} sx={summaryStyle.scrollToAnchor} />
        Aussage zur persönlichen Betroffenheit
      </Grid>
      <Grid size={12}>
        <Box sx={{ whiteSpace: "pre-line" }}>{product.personalAffection.personalAffectionClient}</Box>
      </Grid>
    </>
  );
};

export default PersonalAffection;
